var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.0742188,23.5244141C30.5664062,22.9550781,27.5136719,22,24,22s-6.5664062,0.9550781-8.0732422,1.5244141 C14.7744141,23.9589844,14,25.0849609,14,26.3261719V32h2v-5.6738281c0-0.4140625,0.2539062-0.7880859,0.6328125-0.9306641 C18.0126953,24.8740234,20.8046875,24,24,24s5.9873047,0.8740234,7.3681641,1.3955078 C31.7460938,25.5380859,32,25.9121094,32,26.3261719V32h2v-5.6738281C34,25.0849609,33.2255859,23.9589844,32.0742188,23.5244141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,20c2.8525391,0,5-4.2460938,5-7c0-3.0371094-1.9628906-5-5-5s-5,1.9628906-5,5C19,15.7539062,21.1474609,20,24,20z  M24,10c1.9345703,0,3,1.0654297,3,3c0,2.1025391-1.7382812,5-3,5s-3-2.8974609-3-5C21,11.0654297,22.0654297,10,24,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,4H7C4.2431641,4,2,6.2431641,2,9v22c0,2.7568359,2.2431641,5,5,5h2v6.8789062 C9,44.5996094,10.4003906,46,12.1210938,46c0.8222656,0,1.6259766-0.3330078,2.2070312-0.9140625l8.7929688-8.7929688 C23.3076172,36.1064453,23.5654297,36,23.828125,36H41c2.7568359,0,5-2.2431641,5-5V9C46,6.2431641,43.7568359,4,41,4z M44,31 c0,1.6542969-1.3457031,3-3,3H23.828125c-0.8007812,0-1.5546875,0.3125-2.1210938,0.8789062l-8.7929688,8.7929688 C12.7050781,43.8808594,12.4160156,44,12.1210938,44C11.5029297,44,11,43.4970703,11,42.8789062V36c0-1.1025391-0.8974609-2-2-2H7 c-1.6542969,0-3-1.3457031-3-3V9c0-1.6542969,1.3457031-3,3-3h34c1.6542969,0,3,1.3457031,3,3V31z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMedium);
export default __webpack_public_path__ + "static/media/contact--medium.ab60a544290bcb97a082ab7caef73310.svg";
export { ForwardRef as ReactComponent };